<!-- <div class="leader-board">
    <div class="right-info">
        <div><span *ngIf="numberPrizes" class="label" i18n>Prize distribution:</span><strong i18n>Top {{numberPrizes}} Players</strong></div>
        <div><span class="label" i18n>Minimum bet:</span><strong>{{minBet}} {{minBetCurrency}}</strong></div>
    </div>
    <ng-container *ngIf="achievements">
        <div fxLayout="row" fxLayoutAlign="space-between center" class="list-wrap">
            <h3 i18n>Tournament Rank:</h3>
            <div i18n>Points</div>
        </div>
        <ul class="leader-list">
            <li fxLayout="row" *ngFor="let item of achievements" fxLayoutAlign="space-between center">
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="15px">
                    <img src="assets/desktop/tournament/gold-cup.svg">
                    <span>{{MISSION_LOCALIZED_ACHEVEMENTS[item?.achievementType]}}</span>
                </div>
                <div>
                    {{item?.playerValue}}/{{item?.value}}
                </div>
            </li>
        </ul>
    </ng-container>
</div> -->

<div class="mission-progress" *ngIf="mission else noData">
    <!-- <ul class="list">
        <div fxFlex="85">{{prize?.name}}</div>
    </ul> -->
    <div class="mission-items" [class.linear-bg]="mission.isPrizeEngineEligiblePlayers === true && isLogged">
        <div class="m-head">
            <!-- <div class="m-overlay-content">
                <div class="title">
                    {{mission.name}}
                </div>
                <div class="timer">
                    <span i18n>Mission ends at:</span>&nbsp;{{endDate}}
                </div>
            </div> -->
            <img [src]="mission.thumbnailDesktop?.url">
            <div class="card-img">
                <div class="badge-container-on" *ngIf="mission.isPrizeEngineEligiblePlayers === true && isLogged else others">
                    <img class="live-icon" src="{{licenceService.getKey('compaign-switch')}}" alt="Vector">
                    <span i18n>ON BISON</span>
                </div>
                <ng-template #others>
                    <div class="badge-container batch-bg-0" *ngIf="mission.missionType === 0 && achievementsComplited != _mission.missionsAchievements.length">
                        <img class="live-icon" src="{{licenceService.getKey('batch-icon-mission')}}" alt="missions-active-icon">
                        <span i18n>Active</span>
                    </div>
                    <div class="badge-container batch-bg-4" *ngIf="mission.missionType === 0 && achievementsComplited == _mission.missionsAchievements.length">
                        <img class="live-icon" src="assets/icons/icon-live-mission-completed.svg" alt="missions-active-icon">
                        <span i18n>Completed</span>
                    </div>
                    <div class="badge-container batch-bg-1" *ngIf="mission.missionType === 1">
                        <img class="live-icon" src="{{licenceService.getKey('batch-icon-schedule')}}" alt="badge-icon-1">
                        <span i18n>Starts soon!</span>
                    </div>
                </ng-template>

                <ng-container *ngIf="mission.missionType == 0 && isLogged">
                    <ng-container *ngTemplateOutlet="progressSpiner;"/>
                </ng-container>
            </div>
        </div>
        <div class="m-content">
            <div class="m-section between">
                <div style="width: 100%;" fxLayoutAlign="space-between" fxLayout="column">
                    <h1 class="title-name">{{mission.name | removehtml}}</h1>
                    <div fxLayout="row" fxLayoutGap="8px" class="countdown-wrapper">
                        <img class="mission-type-{{mission.missionType}}" src="assets/desktop/missions/icon-tournament-type-{{mission.missionType}}.svg" alt="icon-tournament-type-{{mission.missionType}}">
                        <!-- <mat-icon class="status-icon">{{mission.missionType === 2?'sports_score':'hourglass_top'}}</mat-icon> -->
                        <span>
                            <ng-container>
                                <div *ngIf="mission.missionType === 0" class="time">
                                    <div #tournamentstartdate></div>
                                    <ng-container *ngIf="tournamentStartDateLocal>now">
                                        {{ tournamentStartDateLocal | date : 'short':'':locale
                                        }}<br />
                                        <span i18n>Starting soon</span>
                                    </ng-container>
                                </div>
                            </ng-container>
                            <div *ngIf="mission.missionType === 1" class="time">{{ tournamentStartDateLocal | date : 'short':'':locale
                                }}
                            </div>
                        </span>
                    </div>
                    <div *ngIf="achievements"><span i18n>{{achievements.length}}</span>&nbsp;&nbsp;Tasks <span>/</span>&nbsp;<span i18n>min bet</span>&nbsp; {{minBet}} {{minBetCurrency}}</div>
                    <!-- <ng-container *ngIf="isCompleted">
                        <div i18n>Completed</div>
                        <div><img width="60px" src="assets/playbison/icons/icon-missions-completed-mission.svg"></div>
                    </ng-container> -->
                </div>
            </div>
            <div class="m-section keep-left">
                <!-- <img [ngClass]="{'completed': isCompleted === true}" width="40px" src="{{isCompleted !== true?licenceService.getKey('icon-mission-logo'):licenceService.getKey('icon-mission-completed')}}"> -->
                <img [ngClass]="{'completed': isCompleted === true}" width="40px" src="assets/playbison/icons/icon-mission-completed.svg">
                <div>
                    <div *ngFor="let prize of mission.prize" class="missions-prize-name">{{prize.name}}</div>
                </div>
            </div>
            <ng-container *ngFor="let achv of achievements;let index = index">
                <div class="m-pounds" [class.one-data-radious]="achievements.length === 1" [ngClass]="{'m-pounds-first-child-radius': index===0, 'completed': achv.isCompleted === true}">
                    <ng-container [ngSwitch]="achv.achievementType">
                        <div class="left-side" *ngSwitchCase="'rounds'"><img *ngIf="achv.isCompleted" src="assets/icons/missions/icon-completed.svg" alt="icon-completed" class="tick"><span i18n>Play</span>&nbsp;{{achv.value}}&nbsp;<span i18n>rounds</span></div>
                        <div class="left-side" *ngSwitchCase="'stake'"><img *ngIf="achv.isCompleted" src="assets/icons/missions/icon-completed.svg" alt="icon-completed" class="tick"><span i18n>Place single bet at least</span>&nbsp;{{achv.value}}&nbsp;<span>{{minBetCurrency}}</span></div>
                        <div class="left-side" *ngSwitchCase="'win_value'"><img *ngIf="achv.isCompleted" src="assets/icons/missions/icon-completed.svg" alt="icon-completed" class="tick"><span i18n>Win at least</span>&nbsp;{{achv.value}}&nbsp;<span>{{minBetCurrency}}</span></div>
                        <div class="left-side" *ngSwitchCase="'win_multiplier'"><img *ngIf="achv.isCompleted" src="assets/icons/missions/icon-completed.svg" alt="icon-completed" class="tick"><span i18n>Win {{achv.value}} x your bet value</span></div>
                        <div class="left-side" *ngSwitchCase="'win_n_times'"><img *ngIf="achv.isCompleted" src="assets/icons/missions/icon-completed.svg" alt="icon-completed" class="tick"><span i18n>Win {{achv.value}} times</span></div>
                    </ng-container>
                    <ng-container [ngSwitch]="achv.achievementType">
                        <div *ngSwitchCase="'stake'">
                            <ng-container [ngTemplateOutlet]="onetimevalue" [ngTemplateOutletContext]="{isCompleted:achv.isCompleted}"></ng-container>

                        </div>
                        <div *ngSwitchCase="'win_value'">
                            <ng-container [ngTemplateOutlet]="onetimevalue" [ngTemplateOutletContext]="{isCompleted:achv.isCompleted}"></ng-container>

                        </div>
                        <div *ngSwitchCase="'win_multiplier'">
                            <ng-container [ngTemplateOutlet]="onetimevalue" [ngTemplateOutletContext]="{isCompleted:achv.isCompleted}"></ng-container>

                        </div>
                        <div *ngSwitchDefault class="spinner-wrapper">
                            <ng-container [ngTemplateOutlet]="spinnervaluer" [ngTemplateOutletContext]="{isCompleted:achv.isCompleted,playerValue:achv.playerValue,totalValue:achv.value }"></ng-container>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </div>
    </div>
</div>

<ng-template #onetimevalue let-iscompleted='isCompleted'>
    <span *ngIf="!iscompleted" i18n>Not yet</span>
    <span *ngIf="iscompleted" class="completed-text" i18n>Completed</span>
</ng-template>
<ng-template #spinnervaluer let-iscompleted='isCompleted' let-playerValue="playerValue" let-totalValue="totalValue">
    <ng-container *ngIf="!iscompleted">
        <div class="spinner-value">
            {{playerValue}}/{{totalValue}}
        </div>
        <!-- <mat-progress-spinner color="accent" mode="determinate" [value]="percent" [diameter]="23" style="stroke-linecap: round;">
        </mat-progress-spinner> -->
    </ng-container>
    <ng-container *ngIf="iscompleted">
        <span class="completed-text" i18n>Completed</span>
    </ng-container>
</ng-template>
<ng-template #noData>
    <p i18n class="no-data">The missions has not started yet.</p>
</ng-template>

<ng-template #progressSpiner>
    <div class="progress-spiner-container" [ngClass]="isDesktop ? 'desktop' : 'mobile'">
        <div class="progress-spiner-background">
            <h3>{{achievementsComplited}}</h3>
            <h4 [ngClass]="achievementsComplited == _mission.missionsAchievements.length ? 'complite' : ''">/ {{_mission.missionsAchievements.length}}</h4>
        </div>
        <mat-progress-spinner #spinnerlevel color="accent" mode="determinate" [value]="spinerValue" [diameter]="isDesktop ? 64 : 56"/>
    </div>
</ng-template>